import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import { DefaultPopoverInnerContent } from 'components/common/Popover/elements'

export const Cell = styled.div`
  vertical-align: middle;
  display: table-cell;
  ${Mixin.clearFix()}
  ${props => props.width && css`
    width: ${props.width}%;
  `}
`

export const ItemText = styled.label`
  text-transform: uppercase;
  font-size: 14px;
  color: ${Theme.colors.dark_grey};
`

export const PriceCell = styled(Cell)`
  text-align: ${props => props.textAlign || 'right'};
  font-weight: 600;
`

export const PopoverContainer = styled.span`
  padding: 5px;
`

export const Title = styled.div`
  margin-bottom: 5px;
`

export const SubTitle = styled.span`
  font-size: 12px;
  line-height: 17px;
  color: ${Theme.colors.dark_grey};
`

export const PopoverInnerContent = styled(DefaultPopoverInnerContent)`
  padding: 15px;
  width: 400px;
  line-height: 1.4em;
  ${Media.mobile`
    z-index: 999;
    width: 290px;
  `}
`
